import { useMemo } from 'react'

import { useOnboarding } from '../../../hooks/useOnboarding'
import { defaultWidgets, defaultWidgetsAfterDayFromRegistering } from '../constants/defaultWidgetsList'
import { groupWidgets } from '../elements/Widgets/elements/VisibleWidgets/elements/VisibleWidgetsList/utils/groupWidgets'

export const useDefaultWidgets = () => {
  const { isAfterDayFromRegistering } = useOnboarding()

  const widgets = useMemo(() => {
    if (isAfterDayFromRegistering) {
      return defaultWidgetsAfterDayFromRegistering
    }

    return defaultWidgets
  }, [isAfterDayFromRegistering])

  return useMemo(() => {
    return {
      hidden: groupWidgets(widgets.hidden).flat(),
      visible: groupWidgets(widgets.visible).flat(),
    }
  }, [widgets])
}
